module.exports = __webpack_public_path__ + "img/panel.60d39539.png";